import React from 'react';
import classNames from 'classnames';

export interface CardProps extends React.HTMLAttributes<HTMLDivElement> {
  header?: React.ReactNode;
  footer?: React.ReactNode;
  bordered?: boolean;
  hoverable?: boolean;
}

const Card: React.FC<CardProps> = ({
  children,
  className,
  header,
  footer,
  bordered = true,
  hoverable = false,
  ...rest
}) => {
  const classes = classNames(
    'ecme-card',
    {
      'hover:shadow-md transition-shadow': hoverable,
      // Pointer only when the card is actually clickable.
      'cursor-pointer': hoverable && !!rest.onClick,
      'border-0': !bordered,
    },
    className
  );

  return (
    <div className={classes} {...rest}>
      {header && <div className="ecme-card-header">{header}</div>}
      <div className="ecme-card-body">{children}</div>
      {footer && <div className="ecme-card-footer">{footer}</div>}
    </div>
  );
};

// Sub-components for more flexibility
export const CardHeader: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({
  children,
  className,
  ...rest
}) => (
  <div className={classNames('ecme-card-header', className)} {...rest}>
    {children}
  </div>
);

export const CardBody: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({
  children,
  className,
  ...rest
}) => (
  <div className={classNames('ecme-card-body', className)} {...rest}>
    {children}
  </div>
);

export const CardFooter: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({
  children,
  className,
  ...rest
}) => (
  <div className={classNames('ecme-card-footer', className)} {...rest}>
    {children}
  </div>
);

export default Card;
